import React, {FC} from 'react';
import {Button} from 'antd';
import {URL_REQUEST_ACCESS_TO_RESTRICTED_AUCTION} from '@joyrideautos/auction-core/src/constants/urls';
import {SizeType} from 'antd/lib/config-provider/SizeContext';

interface RequestAccessProps {
    to?: string;
    size?: SizeType;
    disabled?: boolean;
}

const RequestAccessLink: FC<RequestAccessProps> = ({to, size, disabled}) => {
    const url = disabled ? undefined : to ?? URL_REQUEST_ACCESS_TO_RESTRICTED_AUCTION;
    return (
        <a
            href={url}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
                e.stopPropagation();
            }}>
            <Button type="primary" size={size ?? 'small'} disabled={disabled}>
                Request Access
            </Button>
        </a>
    );
};

export default RequestAccessLink;
